import { BaseRestDataProvider } from './BaseRestDataProvider';
import { VatReturn } from '../models/VatReturn';

export class VatReturnRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/vat-returns');
  }

  getAll(): Promise<VatReturn[]> {
    return this.get<VatReturn[]>(``);
  }

  getById(id: string): Promise<VatReturn> {
    return this.get<VatReturn>(`/${id}`);
  }

  getByPeriod(fiscalYearId: string, quarter: string): Promise<VatReturn | null> {
    return this.get<VatReturn | null>(`/by-period?fiscalYearId=${fiscalYearId}&quarter=${quarter}`);
  }

  add(vatReturn: VatReturn): Promise<VatReturn> {
    return this.post<VatReturn>(``, vatReturn);
  }

  update(id: string, vatReturn: VatReturn): Promise<void> {
    return this.put<void>(`/${id}`, vatReturn);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }

  book(id: string): Promise<void> {
    return this.postVoid(`/${id}/book`);
  }

  unbook(id: string): Promise<void> {
    return this.postVoid(`/${id}/unbook`);
  }

  bookNilDeclaration(id: string): Promise<void> {
    return this.postVoid(`/${id}/book-nil-declaration`);
  }

  calculate(
    fiscalYearId: string,
    quarter: string,
    includePendingCorrections = false,
    correctionTargetField: string | null = null,
    correctionTaxRate: number | null = null,
  ): Promise<VatReturn> {
    let url = `/calculate?fiscalYearId=${fiscalYearId}&quarter=${quarter}&includePendingCorrections=${includePendingCorrections}`;
    if (includePendingCorrections && correctionTargetField)
      url += `&correctionTargetField=${encodeURIComponent(correctionTargetField)}`;
    if (includePendingCorrections && correctionTaxRate != null)
      url += `&correctionTaxRate=${correctionTaxRate}`;
    return this.get<VatReturn>(url);
  }
}
